import { Alert, Icon, IconButton, Stack } from "@chakra-ui/react";
import { timeAgo } from "@keita/lanepatrol-sdk";
import { observer } from "mobx-react";
import { t } from "i18next";
import { useStores } from "../../../../shared/stores/RootStore";
import { CloseIcon } from "../../../../shared/views/icons";

const tPrefix = "coding:conflictWarning";

const ConflictWarningBase: React.FC = () => {
  const { codingStore } = useStores();
  const { conflictWarning } = codingStore;

  if (!conflictWarning) return null;

  return (
    <Alert.Root status="warning" flexShrink={0} borderRadius={0}>
      <Alert.Indicator />
      <Stack gap={0} flexGrow={1}>
        <Alert.Title>{t(`${tPrefix}.title`)}</Alert.Title>
        <Alert.Description fontSize="sm">
          {t(`${tPrefix}.description`, {
            coderName: conflictWarning.coderName,
            timeAgo: timeAgo(new Date(conflictWarning.dateTime)),
          })}
        </Alert.Description>
      </Stack>
      <IconButton
        variant="ghost"
        aria-label="Close"
        onClick={() => codingStore.clearConflictWarning()}
      >
        <Icon as={CloseIcon} />
      </IconButton>
    </Alert.Root>
  );
};

export const ConflictWarning = observer(ConflictWarningBase);
